import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import {
  APP_INITIALIZER,
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { Amplify } from 'aws-amplify';
import { routes } from './app.routes';
import { awsConfig } from './core/configs/aws-exports';
import { authInterceptor } from './core/interceptor/auth.interceptor';
import { cachingInterceptor } from './core/interceptor/caching.interceptor';
import { errorInterceptor } from './core/interceptor/error.interceptor';
import { recaptchaInterceptor } from './core/interceptor/recaptcha.interceptor';
import { RecaptchaService } from './core/services/recaptcha/recaptcha.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideHttpClient(
      withFetch(),
      withInterceptors([
        authInterceptor,
        errorInterceptor,
        cachingInterceptor,
        recaptchaInterceptor,
      ]),
    ),
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [RecaptchaService],
      useFactory: (recaptcha: RecaptchaService) => () => recaptcha.preload(),
    },
  ],
};

// Configure AWS Amplify Auth once at bootstrap
Amplify.configure(awsConfig);

// Normalize OAuth error redirects: if Cognito returns to root ("/") with
// error_description in query string, rewrite URL to "/login" so the router
// loads the login page and shows the error message there.
if (typeof window !== 'undefined') {
  try {
    const currentUrl = new URL(window.location.href);
    const hasErrorDescription = currentUrl.searchParams.has('error_description');
    const isRootPath = currentUrl.pathname === '/' || currentUrl.pathname === '';

    if (hasErrorDescription && isRootPath) {
      const newUrl = `/login${currentUrl.search}`;
      window.history.replaceState(null, '', newUrl);
    }
  } catch {
    // Ignore URL parsing errors in non-browser environments
  }
}
